module.exports = __webpack_public_path__ + "img/gerüstbohlen-möbel-konfigurieren.4be1b2d1.jpeg";